/* globals module, $ */

module.exports = {
	init: function() {
		"use strict";

		var that = this;

		$('input, select, textarea').on('invalid', function() {
			$(this.form).addClass('form--invalid');
		}).on('input change', function() {
			if(this.type === 'radio' || !this.form) {
				return;
			}

			var $fieldset = $(this).closest('fieldset');

			if($fieldset.length && $fieldset[0].getAttribute('data-validate')) {
				that.checkValidity($fieldset[0], false,  false);
			} else {
				that.checkValidity(this.form, false, false);
			}
		});

		$('form').on('submit', function(e) {
			//If clicked button has a data-fieldset attribute, only validate that fieldset
			if(this.submitted && this.submitted.getAttribute('data-fieldset')) {
				var fieldset = document.getElementById(this.submitted.getAttribute('data-fieldset'));

				if(!that.checkValidity(fieldset, true, true)) {
					e.preventDefault();
				}

				return;
			}

			if(!that.checkValidity(this, true, true)) {
				e.preventDefault();
			}
		});

		//Track button used to submit form
		$('button, input').on('click', function() {
			if(this.type === 'submit' && this.form) {
				this.form.submitted = this;
			}
		});

		//Handle <buttons> replaced with <a>s due to "ASP.net limitations"
		$('[data-submit]').on('click', function() {
			var $form = $(this).closest('form');

			if($form.length) {
				$form.prop('submitted', this);
				$form.submit();
			}
		});
	},

	/**
	 * Checks validity of the given form, and updates submit button states as needed
	 *
	 * If the form is invalid, buttons will be given a disabled appearance,
	 * but will remain enabled to allow future validation/submission.
	 *
	 * If the form is valid, buttons will appear enabled.
	 *
	 * @param {HTMLFormElement} form The form to check
	 * @param highlight - If true and the form is invalid, fields will be highlighted by adding the invalid classes
	 * @param scroll - If true will scroll the page to the first invalid element when validation fails
	 */
	checkValidity: function(form, highlight, scroll) {
		"use strict";

		var valid = true,
			buttons = [],
			scrollTarget;

		$(form.elements).each(function() {
			if(this instanceof HTMLFieldSetElement) {
				return;
			}

			if(this instanceof HTMLButtonElement && this.type === 'submit') {
				buttons.push(this);
				return;
			}

			if($(this).hasClass('quantity__input')) {
				return;
			}

			//Manually validate hidden inputs since the browser doesn't
			if(this.type === 'hidden') {
				if(this.required && !this.value) {
					valid = false;

					if(highlight) {
						$(this).closest('.form__group').addClass('form__group--invalid');
					}
				} else {
					$(this).closest('.form__group').removeClass('form__group--invalid');
				}

				return;
			}

			if(!this.validity.valid) {
				valid = false;

				//Set scroll target to label for radio/checkbox inputs
				if(this.type === 'radio' || this.type === 'checkbox') {
					scrollTarget = this.nextElementSibling;
				} else {
					scrollTarget = this;
				}
			}
		});

		//Add <a> "submit buttons" used on checkout to button array because ASP.net
		$(form).find('a.btn').each(function() {
			if(this.hasAttribute('data-submit')) {
				buttons.push(this);
			}
		});

		if(valid) {
			$(form).removeClass('form--invalid');

			buttons.forEach(function(element) {
				$(element).removeClass('btn--disabled');
			});
		} else {
			if(highlight) {
				$(form).addClass('form--invalid');
			}

			buttons.forEach(function(element) {
				$(element).addClass('btn--disabled');
			});

			if(scroll && scrollTarget) {
				var offset = $(scrollTarget).offset().top - ($(window).height() / 2);

				$(document.scrollingElement).animate({
					scrollTop: offset,
				}, 1000);
			}
		}

		return valid;
	}
};
